export default __webpack_public_path__ + "static/media/amazon-sqs.c7babef2f529b7c7fc4a78c97f7fdb87.svg";